import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import { mapFamilyApiError } from '~entities/family/lib/map-family-api-error';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export const removeFamilyContact = async (args: {
  familyId: string;
  parentId: string;
}) => {
  const { familyId, parentId } = args;
  await baseAPI.delete(`/v2/families/${familyId}/contacts/${parentId}`);
};

export const useRemoveFamilyContact = (studentId?: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: removeFamilyContact,
    onSuccess: () => {
      toast.success('Guardian removed from family');
      void queryClient.invalidateQueries({
        queryKey: [KEYS.FAMILY_BY_STUDENT],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.FAMILY_HUB],
      });
    },
    onError: (error: unknown) => {
      toast.error(mapFamilyApiError(error, 'Failed to remove guardian'));
    },
  });
};
